import { initAmplitudeBrowser } from 'amplitude/amplitudeClient'
import { useEffect } from 'react'

/** Initializes Amplitude analytics + Guides & Surveys once the React app shell mounts. */
export const useAmplitudeInit = (): void => {
  useEffect(() => {
    initAmplitudeBrowser()
  }, [])
}
